import { withEventCatcher } from '@repo/event-processor';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui-kit/themeStyle';
import styled from 'styled-components';

import { FlexColumn, FlexRow } from 'styles/layouts';

export const TemplatesPageContentWrapper = styled(FlexColumn)`
  gap: ${themeStyle.spacing32};
`;

export const DiscoverPage = styled(FlexRow)`
  gap: ${themeStyle.spacing2};
  overflow-x: scroll;
  scrollbar-width: none;
`;

export const NonDiscoverPage = styled(FlexColumn)`
  padding: ${themeStyle.spacing16} 0;
`;

export const SwimlaneWrapper = styled(FlexColumn)`
  gap: ${themeStyle.spacing8};
`;

export const SwimlaneTitleWrapper = styled(FlexRow)`
  align-items: center;
  justify-content: space-between;
`;

export const SwimlaneTemplatesWrapper = styled(FlexRow)`
  align-items: baseline;
  justify-content: space-between;
`;

export const CategoryPageWrapper = styled(FlexColumn)`
  gap: ${themeStyle.spacing16};
  padding: ${themeStyle.spacing12} 0;
`;

export const FilterTemplatesSection = styled(FlexRow)`
  gap: ${themeStyle.spacing24};
`;

export const FiltersWrapper = styled(FlexColumn)`
  max-width: 100%;
  height: fit-content;
  position: sticky;
  gap: ${themeStyle.spacing16};

  ${QUERIES.largeTabletAndUp} {
    gap: unset;
    max-width: 250px;
    top: 80px;
    border-radius: ${themeStyle.borderRadius12};
    border: 1px solid ${themeStyle.colorBorder};
    overflow: auto;
    max-height: 85vh; // allow filter to be scrollable on desktops with smaller screens
    scrollbar-color: ${themeStyle.colorBorderTransparent} transparent;

    > *:not(:last-child) {
      border-bottom: 1px solid ${themeStyle.colorBorderTransparent};
    }
  }
`;

export const FiltersClearAllButton = styled(FlexRow)`
  align-items: center;
  gap: ${themeStyle.spacing4};
  padding: 0 ${themeStyle.spacing4};
  cursor: pointer;
  width: fit-content;
`;

export const FilterSection = styled(FlexColumn)`
  position: relative;
  gap: ${themeStyle.spacing8};
  padding: ${themeStyle.spacing16};
  border-radius: ${themeStyle.borderRadius12};
  border: 1px solid ${themeStyle.colorBorder};

  ${QUERIES.largeTabletAndUp} {
    border-radius: unset;
    border: unset;
  }
`;

export const FilterTagsContainer = styled.div<{ isExpanded: boolean }>`
  position: relative;
  display: flex;
  gap: ${themeStyle.spacing4};
  flex-wrap: wrap;
  overflow: ${(props) => (props.isExpanded ? 'scroll' : 'hidden')};
  height: ${(props) => (props.isExpanded ? '250px' : '140px')};
`;

export const FilterTagsGradient = styled.div<{ showGradient: boolean }>`
  position: absolute;
  bottom: 45px;
  height: ${(props) => (props.showGradient ? '20px' : '0px')};
  width: 100%;
  background: -webkit-linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 2.5%,
    #fff 100%
  );
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 2.5%, #fff 100%);
  pointer-events: none;
  opacity: ${(props) => (props.showGradient ? 1 : 0)};
  transition: opacity 0.2s ease;
`;

const _ShowAllShowLess = styled.div`
  cursor: pointer;
  padding-top: ${themeStyle.spacing6};
`;

export const ShowAllShowLess = withEventCatcher(_ShowAllShowLess);

export const ColorSection = styled(FlexRow)`
  gap: ${themeStyle.spacing8};
  flex-wrap: wrap;
`;

const _ColorFilter = styled.div<{
  isSelected: boolean;
  hexColor: string;
}>`
  width: 20px;
  height: 20px;
  cursor: pointer;
  background-color: ${(props) => props.hexColor};
  border-radius: 100%;
  border: ${(props) =>
    props.isSelected
      ? `2px solid ${themeStyle.colorBorderFocused}`
      : `1px solid ${themeStyle.colorBorderTransparent}`};
`;

export const ColorFilter = withEventCatcher(_ColorFilter);

export const SwimlaneDetailedPageContent = styled(FlexColumn)`
  padding: 0 ${themeStyle.spacing16};
  gap: ${themeStyle.spacing16};

  ${QUERIES.tabletAndUp} {
    padding: 0;
  }
`;

export const HeaderSection = styled(FlexColumn)`
  gap: ${themeStyle.spacing8};
  padding-bottom: ${themeStyle.spacing12};
`;

export const BackButton = styled(FlexRow)`
  padding-left: ${themeStyle.spacing16};

  ${QUERIES.tabletAndUp} {
    padding-left: unset;
  }
`;

export const CounterWrapper = styled(FlexRow)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${themeStyle.borderRadius10};
  background: ${themeStyle.colorIconActive};
  color: ${themeStyle.colorTextBrandOnBg};
  padding: 0 ${themeStyle.spacing6};
  height: 16px;
  width: 16px;
  font-size: 8px;
  font-weight: 625;
`;
